export default {
  // Navigation
  about: "About",
  skills: "Skills",
  services: "Services",
  portfolio: "Portfolio",
  contact: "Contact",

  // Header
  title: "BRAIN PLAY",
  subtitle: "Software · Hardware · Engineering Consulting",

  // About
  aboutTitle: "About",
  name: "Gyeong Seop Sim",
  role: "Full-stack Software & Hardware Engineer",
  bio: "Developer specializing in web services, backend systems, embedded hardware, automation, sensor integration, and custom engineering solutions. Experienced in both small MVPs and complex enterprise-grade systems.",

  // Skills
  skillsTitle: "Skills",
  webFrontend: "Web Frontend",
  backend: "Backend",
  programming: "Programming",
  embedded: "Embedded / Hardware",
  systems: "Systems & Automation",
  platforms: "Platforms",
  general: "General",

  // Services
  servicesTitle: "Services",
  webDev: "Web Development (Frontend & Backend)",
  apiServer: "API and Server Architecture",
  embeddedDesign: "Embedded System Design",
  sensorIntegration: "Custom Controller / Sensor Integration",
  prototyping: "Electronics Prototyping & Hardware Consulting",
  automation: "Automation & Network System Design",
  consulting: "Full end-to-end engineering consulting",

  // Portfolio
  portfolioTitle: "Portfolio",
  webDashboards: "Web dashboards",
  iotControllers: "IoT controllers",
  automationModules: "Automation modules/systems",
  sensorSystems: "Sensor-based embedded systems",
  hardwarePrototypes: "Custom hardware prototypes",

  // Contact
  contactTitle: "Contact",
  phone: "Phone",
  email: "Email",
  website: "Website",
  contactForm: "Contact Form",
  nameField: "Name",
  emailField: "Email",
  messageField: "Message",
  sendMessage: "Send Message",

  // Language
  language: "Language",
  korean: "한국어",
  english: "English"
};